import React, { PropTypes } from 'react';
import Select from 'common/Select';
import { intlShape } from 'common/injectIntl';
import findIndex from 'lodash/findIndex';
import { dateFormat } from 'lib/format';
import DateSlider from './DateSlider';
import StatusFilter from './StatusFilter';

const FilterGroup = ({
    isIntl,
    location,
    isResponsive,
    categories,
    channels,
    onDateSelectorChange,
    onStatusFilterChange,
    onSportsFilterChange,
    onNetworkFilterChange,
    showSportOptions,
    showNetworkOptions,
    messages,
    intl: { formatMessage }
}) => {
    const query = location.query;
    const statusDefaultSelection = query.type || StatusFilter.Options.LIVE;
    const watchRegion = query.watchRegion;
    const sportOptions = showSportOptions ?
        [{ label: formatMessage(messages['schedule.allSports']), value: undefined, type: 'category' }]
        .concat(categories.map((cat) => ({ label: cat.name || cat.guid, value: cat.guid, type: cat.type, id: cat.id }))) : null;

    const networkOptions = showNetworkOptions ? [{ label: formatMessage(messages['schedule.allNetworks']), value: '' }]
        .concat(
            [...channels]
            .map((channel) => ({
                label: channel.name,
                value: channel.guid,
                id: channel.guid
            }))
        ) : null;
    const sportDefaultSelection = sportOptions &&
        findIndex(sportOptions, (option) => (option.value === query.categoryId));
    const networkDefaultSelection = networkOptions && findIndex(networkOptions, (option) => (option.value === query.channel));

    const hasDatesParam = query.dates && /^\d{8}/.test(query.dates); // This is meant to be for syndicated player
    let startDateStr = query.startDate;
    let sliderDateStr;
    let maxDaysInFuture;
    if (hasDatesParam) {
        const [start, end] = query.dates.split('-');
        const today = dateFormat.dateToKey(new Date());
        startDateStr = today < start ? start : today;
        if (end && end > startDateStr) {
            const endDateStr = end;
            maxDaysInFuture = (parseInt(endDateStr, 10) - parseInt(startDateStr, 10)) + 1;
        }
        sliderDateStr = startDateStr;
    }
    const sliderDate = dateFormat.paramToDate(sliderDateStr) || new Date();
    const dateSelector = statusDefaultSelection === StatusFilter.Options.UPCOMING ? (
        <DateSlider
            date={sliderDate}
            onDateSelected={onDateSelectorChange}
            maxDaysInFuture={maxDaysInFuture}
            isResponsive={isResponsive}
            isIntl={isIntl}
            messages={messages}
            formatMessage={formatMessage}
            watchRegion={watchRegion}
        />
    ) : null;
    let replayDateSelector = null;
    if (statusDefaultSelection === StatusFilter.Options.REPLAY) {
        const isReplaySlider = true;
        replayDateSelector = (
            <DateSlider
                date={sliderDate}
                onDateSelected={onDateSelectorChange}
                maxDaysInFuture={0}
                maxDaysInPast={30}
                isResponsive={isResponsive}
                isReplaySlider={isReplaySlider}
                isIntl={isIntl}
                messages={messages}
                formatMessage={formatMessage}
                watchRegion={watchRegion}
            />
        );
    }

    const needSeparator = sportOptions || networkOptions || replayDateSelector;

    return (
        <div className="filter-group-wrap">
            <StatusFilter
                selected={statusDefaultSelection}
                handleClick={onStatusFilterChange}
                labels={{
                    [StatusFilter.Options.LIVE]: formatMessage(messages['schedule.live']),
                    [StatusFilter.Options.UPCOMING]: formatMessage(messages['schedule.upcoming']),
                    [StatusFilter.Options.REPLAY]: formatMessage(messages['schedule.replay'])
                }}
            />

            <div className={needSeparator ? 'filters' : ''}>
                {sportOptions ? <Select
                    defaultSelection={sportDefaultSelection}
                    options={sportOptions}
                    onChange={onSportsFilterChange}
                /> : null}
                {networkOptions ? <Select
                    defaultSelection={networkDefaultSelection}
                    options={networkOptions}
                    onChange={onNetworkFilterChange}
                /> : null}
            </div>
            <div className="replaydate-wrap">
                {replayDateSelector}
            </div>
            <div className="datepicker-wrap">
                {dateSelector}
            </div>
        </div>
    );
};

FilterGroup.propTypes = {
    categories: PropTypes.array,
    channels: PropTypes.array,
    onSportsFilterChange: PropTypes.func,
    onNetworkFilterChange: PropTypes.func,
    onDateSelectorChange: PropTypes.func,
    onStatusFilterChange: PropTypes.func,
    location: PropTypes.object,
    isIntl: PropTypes.bool,
    showSportOptions: PropTypes.bool,
    showNetworkOptions: PropTypes.bool,
    isResponsive: PropTypes.bool,
    intl: intlShape.isRequired,
    messages: PropTypes.object.isRequired
};

FilterGroup.defaultProps = {
    categories: [],
    channels: [],
    showSportOptions: true,
    showNetworkOptions: true
};

export default FilterGroup;



// WEBPACK FOOTER //
// ./app/common/schedule/FilterGroup.js